import Model, { hasMany, attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type DistrictCoordinator from 'teacher-ui-client/models/district-coordinator'
import type StringTransform from 'teacher-ui-client/transforms/string'

export default class District extends Model {
  @attr<StringTransform>('string') declare name: string

  @hasMany<DistrictCoordinator>('district-coordinator', { async: false, inverse: null })
  declare districtCoordinators?: DistrictCoordinator[];

  [Type] = 'district' as const
}
